// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const fieldGroupClasses = {
  errorText: "qui-field-group__error-text",
  hint: "qui-field-group__hint",
  items: "qui-field-group__items",
  label: "qui-field-group__label",
  root: "qui-field-group__root",
} as const
